function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert } from "@ember/debug";
import JournalEvent from "core/models/journal-event";
export default class VitalSign {
  static findByJournalEventType(eventType) {
    return VitalSign._vitalSigns.get(eventType);
  }
  static findByKey(key) {
    return Array.from(VitalSign._vitalSigns.values()).find(vitalSign => vitalSign.key == key);
  }
  get feature() {
    return this.addMeasureForcId?.split("/")[0];
  }
  get component() {
    return this.addMeasureForcId?.split("/")[1];
  }
  constructor({
    key,
    addMeasureForcId,
    addMeasureForcIdMedic,
    journalEventType,
    icon,
    tooltipIcon,
    showToPatient,
    contextualDeclareRoute
  }) {
    _defineProperty(this, "key", void 0);
    _defineProperty(this, "journalEventType", void 0);
    _defineProperty(this, "addMeasureForcId", void 0);
    _defineProperty(this, "addMeasureForcIdMedic", void 0);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "tooltipIcon", void 0);
    _defineProperty(this, "showToPatient", void 0);
    _defineProperty(this, "contextualDeclareRoute", void 0);
    this.key = key;
    this.addMeasureForcId = addMeasureForcId;
    this.addMeasureForcIdMedic = addMeasureForcIdMedic || addMeasureForcId;
    this.journalEventType = journalEventType;
    this.icon = icon;
    this.tooltipIcon = tooltipIcon;
    this.showToPatient = showToPatient;
    this.contextualDeclareRoute = contextualDeclareRoute;
    assert("Journal Event type should be defined and should be a '*-journal-event' string", Boolean(journalEventType.type));
    VitalSign._vitalSigns.set(journalEventType.type, this);
  }
}
_defineProperty(VitalSign, "_vitalSigns", new Map());